import { CollapseNoDefaultMotion } from '@/components/collapse-no-default-motion/CollapseNoDefaultMotion';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { HttpApiServerType } from '@/services/http-api/httpApi';
import { Collapse } from 'aui';
import clsx from 'clsx';
import React from 'react';
import { CollapseHeader } from './components/collapse-header/CollapseHeader';
import { ResponsePanel } from './components/response-panel/ResponsePanel';
import { useResponseParameterValue } from './hooks/useResponseParameterValue';
import styles from './ResponseParameter.module.css';
export type ResponseParameterProps = {
  value: HttpApiServerType;
  className?: string;
};

export function ResponseParameter(props: ResponseParameterProps) {
  const { value, className } = props;
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  const { activeKey, onChange, responses } = useResponseParameterValue(value);

  const isUserChangedRef = React.useRef(false);

  return (
    <div className={clsx(className)}>
      <h2 className="_response-title mb-4 text-xl font-600">{clientI18n('api.label.responses')}</h2>

      {!responses && (
        <div className="flex h-[100px] w-full items-center justify-center rounded border border-dashed border-color-split">
          {clientI18n('api.parameterLabel.noNeedToDefineTheResponse')}
        </div>
      )}

      {responses && (
        <CollapseNoDefaultMotion
          accordion
          expandIconPosition="end"
          className={styles.collapse}
          activeKey={activeKey}
          onChange={(v) => {
            isUserChangedRef.current = true;
            onChange(v);
          }}
        >
          {responses.map((x, i) => {
            const key = String(x.id ?? i);

            return (
              <Collapse.Panel key={key} header={<CollapseHeader value={x} />}>
                {(isUserChangedRef.current || i === 0) && <ResponsePanel value={x} />}
              </Collapse.Panel>
            );
          })}
        </CollapseNoDefaultMotion>
      )}
    </div>
  );
}
